import './Footer.css';

const Footer = () => {
    return(
        <div className='footer'>
            <a href="https://agenciaforest.com/" target='_blank'><img src='./images/forest.png' alt='logo forest' /></a>
        </div>
    );
}

export default Footer;